module.exports = __webpack_public_path__ + "img/Frame6.11cd498d.png";